export default {
  title01: "Meteo attuale",
  title02: "24 ore",
  title03: "Visualizza previsioni meteo a 10 giorni",
  title04: "AQI",
  title05: "Visualizza tutte le informazioni",
  title06: "ALBA E TRAMONTO",
  title07: "FASE LUNARE",
  title08: "La prossima luna piena",
  title09: "La prossima luna nuova",
  title10: "GIORNO",
  title11: "NOTTE",
  title12: "Alba",
  title13: "Tramonto",
  title14: "Sorgere della luna",
  title15: "Tramonto della luna",
  title16: "Fonte",
  title17: "Inizio",
  title18: "Fine",
  title19: "Usa posizione attuale",
  title20: "Cerca la città",
  title21: "Sembra",
  title22: "Sembra ombra",
  title23: "Adesso",
  title24: "Oggi",
  title25: "DOM",
  title26: "LUN",
  title27: "MAR",
  title28: "MER",
  title29: "GIO",
  title30: "VEN",
  title31: "SAB",
  title32: "Caricamento...",
  title33: "Ora",
  title34: "Per Ora",
  title35: "Quotidiano",
  title36: "Sole e Luna",
  title37: "Qualità dell'aria",
  title38: "Contatto: xlf550402@gmail.com",
  title39: "Accordo sulla Privacy",
  title40: "Copyright © comfortweather.com 2020 - 2026. Tutti i diritti riservati.",
  title41: "Dati forniti da",
  title42: "Max",
  title43: "Min",
  title44: "Accetta",
  title45:
    "Grazie per aver utilizzato ComfortWeather! Per tutelare al meglio i vostri diritti e interessi legali, vi invitiamo a leggere attentamente la ",
  title46: "Politica sulla privacy",
  title47: " prima di utilizzarla.",
  title48: "",
  title49: "Contatto: xyjph123@gmail.com",
  title50: "Copyright © 24hweather.com 2020 - 2026. Tutti i diritti riservati.",
  title51:
    "Grazie per aver utilizzato 24hweather! Per tutelare al meglio i vostri diritti e interessi legali, vi invitiamo a leggere attentamente la ",
  title52: "La tua posizione è cambiata. Vuoi aggiornarla?",
  title53: "Conferma",
  title54: "Cancella ",
  title55: "Indietro",
  title56: "Novità",
  title57: "Aggiornamento del meteo...",
  title58: "Meteo aggiornato",
  title59: "Vedi tutto",
  title60: "Copyright © mobi321.com 2020 - 2026. Tutti i diritti riservati.",
  title61: "Ieri",
  title62: "Domani",
  title63: "Visualizza previsioni meteo a 15 giorni",
  title64: "Dettagli di oggi",
  title65: "Rahu Kaal",
  title66: "Indici di stile di vita",
  title67: "Indici di stile di vita",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Difficile da asciugare",
  title103: "Asciugatura lenta",
  title104: "Si asciuga bene",
  title105: "Asciugatura veloce",
  title106: "Asciugatura rapidissima",

  title107: "Non adatto",
  title108: "Esperienza modesta",
  title109: "Buono per divertimento in acqua",
  title110: "Molto adatto per giocare in acqua",
  title111: "Condizioni perfette",

  title112: "Favorevole alla salute",
  title113: "Condizioni normali",
  title114: "Rischio leggermente più alto",
  title115: "Alto rischio",
  title116: "Estremo rischio",

  title117: "Non adatto",
  title118: "Adatto per breve tempo",
  title119: "Adatto per stare all'aperto",
  title120: "Molto adatto",
  title121: "Condizioni eccellenti",

  title122: "Condizioni di secchezza estreme",
  title123: "Probabile secchezza",
  title124: "Leggera secchezza",
  title125: "Non probabile secchezza",
  title126: "Molto improbabile che sia secco",

  title127: "Non consigliato",
  title128: "Accettabile",
  title129: "Buona giornata",
  title130: "Condizioni molto buone",
  title131: "Condizioni ideali",
};
